export const name = "ST_DIMENSION";
export const summary = `Gets the dimension of the highest-dimensional element in a \`GEOGRAPHY\` value.`;
export const reference = `
## ST_DIMENSION

Gets the dimension of the highest-dimensional element in a \`GEOGRAPHY\` value.

\`\`\`
ST_DIMENSION(geography_expression)
\`\`\`

### Description

Returns the dimension of the highest-dimensional element in the input\`GEOGRAPHY\`.

The dimension of each possible element is as follows:

- The dimension of a point is \`0\`.
- The dimension of a linestring is \`1\`.
- The dimension of a polygon is \`2\`.

If the input \`GEOGRAPHY\` is empty, \`ST_DIMENSION\`returns \`-1\`.


### Return type

\`INT64\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
